import { api } from "assets/scripts/utilities/api-clients";

export const cancel = async (params) => {
  const { pod, removeFiles, path = "kam" } = params;
  const endpoints = {
    kam: {
      pod: {
        cancel: "/kam/pods",
      },
    },
    account: {
      pod: {
        cancel: "/account/pods",
      },
    },
  };
  const response = await api.put(endpoints[path].pod.cancel, {
    _id: pod._id,
    reason: pod.reason,
    isFilesToBeRemoved: removeFiles,
  });

  return response;
};

export const get = async ({ id, source, options = {} }) => {
  const url = {
    kam: `/kam/pods/${id}`,
    sales: `/sales/pod/${id}`,
  };
  const response = await api.get(url[source], options);

  return response;
};

export const index = async (options = {}) => {
  const { source = "kam", ...rest } = options;
  const url = {
    kam: "/kam/pods",
    sales: "/sales/pods",
  };
  const response = await api.get(url[source], rest);

  return response;
};

export const post = async (
  pod,
  options = {
    params: {
      showMessage: false,
    },
  },
) => {
  const response = await api.post("/kam/pods", pod, options);

  return response;
};

export const put = async (
  pod,
  options = {
    params: {
      showMessage: false,
    },
  },
) => {
  const response = await api.put("/kam/pods", pod, options);

  return response;
};

export const checkNumber = async (number) => {
  const response = await api.post("/kam/pods/active", number);

  return response;
};
